<template>
  <div>
    <img class="shiji" src="../../../assets/images/shiji payment logo.png" />
    <!-- <span class="title" :class="[language==='cn'?'letter':'']">{{$t('login.title')}}</span> -->
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import RightPanel from "@/components/RightPanel";
import Screenfull from "@/components/Screenfull";
import LangSelect from "@/components/LangSelect";
import Cookies from "js-cookie";

import bus from "@/utils/bus";
import { removeToken } from "@/utils/auth"; // 验权
export default {
  data() {
    return {
      content: "root",
    };
  },
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    RightPanel,
    LangSelect,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device", "userInfo", "language"]),
    userCode() {
    let userCode = "";
    if (this.userInfo.authUser) {
      userCode = this.userInfo.authUser.userName;
    }
    return userCode;
  },
  },
 
  methods: {
    onDrawer() {
      bus.$emit("onDrawer", true);
    },

    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.shiji {
  height: 40px;
  // width: 129px;
  margin: 5px 0 0 42px;
  /* vertical-align: super; */
  vertical-align: 6px;
}

.title {
  font-size: 20px;
  /*padding: 0 10px;*/
  font-family: AdobeHeitiStd-Regular, AdobeHeitiStd;
  /*letter-spacing: 3px;*/
  line-height: 50px;
  font-weight: 600;
}

.letter {
  letter-spacing: 1px;
}

.navbar-v.margin-ave {
  transition: margin-left 0.3s;
  margin-left: 40px !important;
}

.hamburger-container {
  line-height: 58px;
  height: 50px;
  width: 50px;
  float: left;
  /*padding: 0 10px;*/
  text-align: center;
  background: #1a65ba;
}

.right-menu {
  float: right;
  height: 100%;
  line-height: 50px;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    margin-right: 30px;

    .avatar-wrapper {
      margin-top: 5px;
      position: relative;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}

.box-item {
  display: flex;
  /*justify-content: center;*/
  align-items: center;
  border-radius: 4px;
  min-height: 30px;
  padding: 0 10px;
  background: #faf9fa;
  cursor: pointer;
  margin-bottom: 10px;
  white-space: nowrap; /*强制文本一行显示*/
  overflow: hidden; /*超出元素默认宽度内容隐藏*/
  text-overflow: ellipsis; /*使用省略号代表有内容未显示*/
  font-size: 13px;
  line-height: 35px;
}

.box-item:hover {
  background: #f4f3f4;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppHeader2.vue